"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MidiControlChange = void 0;
/**
 * Midi Control Change message types.
 */
var MidiControlChange;
(function (MidiControlChange) {
    MidiControlChange[MidiControlChange["BankSelect"] = 0] = "BankSelect";
    MidiControlChange[MidiControlChange["ModulationWheel"] = 1] = "ModulationWheel";
    MidiControlChange[MidiControlChange["BreathController"] = 2] = "BreathController";
    MidiControlChange[MidiControlChange["FootController"] = 4] = "FootController";
    MidiControlChange[MidiControlChange["PortamentoTile"] = 5] = "PortamentoTile";
    MidiControlChange[MidiControlChange["DataEntryMSB"] = 6] = "DataEntryMSB";
    MidiControlChange[MidiControlChange["ChannelVolume"] = 7] = "ChannelVolume";
    MidiControlChange[MidiControlChange["Balance"] = 8] = "Balance";
    MidiControlChange[MidiControlChange["Pan"] = 10] = "Pan";
    MidiControlChange[MidiControlChange["ExpressionController"] = 11] = "ExpressionController";
    MidiControlChange[MidiControlChange["EffectControl1"] = 12] = "EffectControl1";
    MidiControlChange[MidiControlChange["EffectControl2"] = 13] = "EffectControl2";
    MidiControlChange[MidiControlChange["GeneralPurposeController1"] = 16] = "GeneralPurposeController1";
    MidiControlChange[MidiControlChange["GeneralPurposeController2"] = 17] = "GeneralPurposeController2";
    MidiControlChange[MidiControlChange["GeneralPurposeController3"] = 18] = "GeneralPurposeController3";
    MidiControlChange[MidiControlChange["GeneralPurposeController4"] = 19] = "GeneralPurposeController4";
    // LSB section
    MidiControlChange[MidiControlChange["BankSelectLSB"] = 32] = "BankSelectLSB";
    MidiControlChange[MidiControlChange["ModulationWheelLSB"] = 33] = "ModulationWheelLSB";
    MidiControlChange[MidiControlChange["BreathControllerLSB"] = 34] = "BreathControllerLSB";
    MidiControlChange[MidiControlChange["FootControllerLSB"] = 36] = "FootControllerLSB";
    MidiControlChange[MidiControlChange["PortamentoTileLSB"] = 37] = "PortamentoTileLSB";
    MidiControlChange[MidiControlChange["DataEntryLSB"] = 38] = "DataEntryLSB";
    MidiControlChange[MidiControlChange["ChannelVolumeLSB"] = 39] = "ChannelVolumeLSB";
    MidiControlChange[MidiControlChange["BalanceLSB"] = 40] = "BalanceLSB";
    MidiControlChange[MidiControlChange["PanLSB"] = 42] = "PanLSB";
    MidiControlChange[MidiControlChange["ExpressionControllerLSB"] = 43] = "ExpressionControllerLSB";
    MidiControlChange[MidiControlChange["EffectControl1LSB"] = 48] = "EffectControl1LSB";
    MidiControlChange[MidiControlChange["EffectControl2LSB"] = 49] = "EffectControl2LSB";
    MidiControlChange[MidiControlChange["EffectControl3LSB"] = 50] = "EffectControl3LSB";
    MidiControlChange[MidiControlChange["EffectControl4LSB"] = 51] = "EffectControl4LSB";
    // binary ones
    MidiControlChange[MidiControlChange["Sustain"] = 64] = "Sustain";
    MidiControlChange[MidiControlChange["Portamento"] = 65] = "Portamento";
    MidiControlChange[MidiControlChange["Sostenuto"] = 66] = "Sostenuto";
    MidiControlChange[MidiControlChange["SoftPedal"] = 67] = "SoftPedal";
    MidiControlChange[MidiControlChange["LegatoFootswitch"] = 68] = "LegatoFootswitch";
    MidiControlChange[MidiControlChange["Hold2"] = 69] = "Hold2";
    MidiControlChange[MidiControlChange["SoundController1"] = 70] = "SoundController1";
    MidiControlChange[MidiControlChange["SoundController2"] = 71] = "SoundController2";
    MidiControlChange[MidiControlChange["SoundController3"] = 72] = "SoundController3";
    MidiControlChange[MidiControlChange["SoundController4"] = 73] = "SoundController4";
    MidiControlChange[MidiControlChange["SoundController5"] = 74] = "SoundController5";
    MidiControlChange[MidiControlChange["SoundController6"] = 75] = "SoundController6";
    MidiControlChange[MidiControlChange["SoundController7"] = 76] = "SoundController7";
    MidiControlChange[MidiControlChange["SoundController8"] = 77] = "SoundController8";
    MidiControlChange[MidiControlChange["SoundController9"] = 78] = "SoundController9";
    MidiControlChange[MidiControlChange["SoundController10"] = 79] = "SoundController10";
    /* Alternative names for 70-78 */
    MidiControlChange[MidiControlChange["SoundVariation"] = 70] = "SoundVariation";
    MidiControlChange[MidiControlChange["TimbreIntensitivity"] = 71] = "TimbreIntensitivity";
    MidiControlChange[MidiControlChange["ReleaseTime"] = 72] = "ReleaseTime";
    MidiControlChange[MidiControlChange["AttackTime"] = 73] = "AttackTime";
    MidiControlChange[MidiControlChange["Brightness"] = 74] = "Brightness";
    MidiControlChange[MidiControlChange["DecayTime"] = 75] = "DecayTime";
    MidiControlChange[MidiControlChange["VibratoRate"] = 76] = "VibratoRate";
    MidiControlChange[MidiControlChange["VibratoDepth"] = 77] = "VibratoDepth";
    MidiControlChange[MidiControlChange["VibratoDelay"] = 78] = "VibratoDelay";
    MidiControlChange[MidiControlChange["GeneralPurposeController5"] = 80] = "GeneralPurposeController5";
    MidiControlChange[MidiControlChange["GeneralPurposeController6"] = 81] = "GeneralPurposeController6";
    MidiControlChange[MidiControlChange["GeneralPurposeController7"] = 82] = "GeneralPurposeController7";
    MidiControlChange[MidiControlChange["GeneralPurposeController8"] = 83] = "GeneralPurposeController8";
    MidiControlChange[MidiControlChange["PortamentoControl"] = 84] = "PortamentoControl";
    MidiControlChange[MidiControlChange["HighResolutionVelocityPrefix"] = 88] = "HighResolutionVelocityPrefix";
    MidiControlChange[MidiControlChange["Effects1Depth"] = 91] = "Effects1Depth";
    MidiControlChange[MidiControlChange["Effects2Depth"] = 92] = "Effects2Depth";
    MidiControlChange[MidiControlChange["Effects3Depth"] = 93] = "Effects3Depth";
    MidiControlChange[MidiControlChange["Effects4Depth"] = 94] = "Effects4Depth";
    MidiControlChange[MidiControlChange["Effects5Depth"] = 95] = "Effects5Depth";
    MidiControlChange[MidiControlChange["DataIncrement"] = 96] = "DataIncrement";
    MidiControlChange[MidiControlChange["DataDecrement"] = 97] = "DataDecrement";
    MidiControlChange[MidiControlChange["NonRegisteredParameterNumberLSB"] = 98] = "NonRegisteredParameterNumberLSB";
    MidiControlChange[MidiControlChange["NonRegisteredParameterNumberMSB"] = 99] = "NonRegisteredParameterNumberMSB";
    MidiControlChange[MidiControlChange["RegisteredParameterNumberLSB"] = 100] = "RegisteredParameterNumberLSB";
    MidiControlChange[MidiControlChange["RegisteredParameterNumberMSB"] = 101] = "RegisteredParameterNumberMSB";
    // Channel Mode messages
    MidiControlChange[MidiControlChange["AllSoundsOff"] = 120] = "AllSoundsOff";
    MidiControlChange[MidiControlChange["ResetAllControllers"] = 121] = "ResetAllControllers";
    MidiControlChange[MidiControlChange["LocalControlOnOff"] = 122] = "LocalControlOnOff";
    MidiControlChange[MidiControlChange["AllNotesOff"] = 123] = "AllNotesOff";
    MidiControlChange[MidiControlChange["OmniModeOff"] = 124] = "OmniModeOff";
    MidiControlChange[MidiControlChange["OmniModeOn"] = 125] = "OmniModeOn";
    MidiControlChange[MidiControlChange["MonoModeOn"] = 126] = "MonoModeOn";
    MidiControlChange[MidiControlChange["PolyModeOn"] = 127] = "PolyModeOn";
})(MidiControlChange = exports.MidiControlChange || (exports.MidiControlChange = {}));
